import React, { useEffect, useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, LineController, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import { API } from "aws-amplify";

ChartJS.register(LineElement, PointElement, LineController, CategoryScale, LinearScale, Title, Tooltip, Legend);

interface TemperatureChartProps {
    storeId: number;
    machineLogicalName: string;

}
interface MachineTemperatureDto {
    StoreId: number;
    MachineLogicalName?: string | null;
    Timestamp: string; // ISO date-time string
    NoOfSamples: number;
    WorkingTemperature: number;
    Temperature: number;
    AmbientTemperature: number;
}

const TemperatureChart: React.FC<TemperatureChartProps> = ({ storeId, machineLogicalName }) => {
    const [temps, setTemps] = useState<MachineTemperatureDto[] | null>(null);

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;
        const fetchStatus = () => {
            API.get("AE", `/Stores/MachineTemperaturesLast24h?storeId=${storeId}&machineLogicalName=${encodeURIComponent(machineLogicalName)}`, { response: true })
                .then(res => {
                    setTemps(res.data as MachineTemperatureDto[]);
                })
                .catch(() => {
                });
        };
        fetchStatus();
        intervalId = setInterval(fetchStatus, 60000);
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [machineLogicalName, storeId]);


    const labels = temps
        ? temps.map(t => {
            const date = new Date(t.Timestamp);
            return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
        })
        : ["08:00", "09:00", "10:00", "11:00", "12:00"];

    const dataSet = [
        {
            data: temps ? temps.map(t => t.Temperature) : [1],
            borderColor: "#1976d2",
            backgroundColor: "rgba(25, 118, 210, 0.2)",
            pointRadius: 0,
            tension: 0.4,
        },
        {
            data: temps ? temps.map(t => t.WorkingTemperature) : [10],
            borderColor: "#d22f19ff",
            backgroundColor: "rgba(25, 118, 210, 0.2)",
            pointRadius: 0,
            borderDash: [4, 4],
            borderWidth: 1
        }
    ];
    const data = {
        labels,
        datasets: dataSet,
    };
    const options = {
        scales: {
            y: {
                beginAtZero: false,
                min: temps ? Math.min(...temps.map(t => t.Temperature)) - 1 : undefined,
                ticks: {
                    stepSize: 1,
                },
                title: {
                    display: true,
                    text: '°C'
                }
            },
            x: {
                title: {
                    display: false,
                    text: 'Time'                    
                },
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 12,
                    
                }
            }
        },
        plugins: {
            title: {
                display: false,
                text: 'Machine Temperature Over Time'
            },
            legend: {
                display: false
            }
        }
    };
    return (
        <div style={{ overflow: 'auto' }}>
            {temps && temps.length > 0 ?
                <Line data={data} options={options} />
            : <p>No temperature data available</p>}
        </div>
    );
};

export default TemperatureChart;
